import React, { Component } from "react";
import Footer from "components/Common/Footer";
import PropTypes from "prop-types";
import { Record } from "immutable";

import isEmail from "validator/lib/isEmail";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  checkTFA, setState, resetPassword, loginUser as loginUserAction
} from "actions";

import { Client } from "resourceModels";
import { fetchOne } from "actions/resources";
import { setPageAction } from "actions/router";
import { trackReactComponentError } from "services/errorTracker";
import { getResource } from "selectors/resources";

import Canvas from "components/Common/Canvas";
import Loading from "components/Common/Loading";
import {
  resetOAuthRequirements,
  resetNotificationError as ResetErrorNotificationAction
} from "./actions";
import BaseLoginForm from "./Forms/BaseLogin";
import PasswordResetForm from "./Forms/ResetPassword";
import PasswordResetEmailConfirmation from "./PasswordResetEmailConfirmation";
import OauthForm from "./Forms/Oauth";

import "./style.scss";
import EnforcedMFA from "./EnforcedMFA";

export class Login extends Component {
  state = {
    isEmailValid: true,
    showEmailConfirmation: false,
    password: "",
    TFA: ""
  };

  /**
   * Hooks
   */

  /**
   */
  componentDidMount() {
    const {
      /** @type Client */
      client,
      fetchClient
    } = this.props;

    if (!client) {
      fetchClient();
    }
  }

  /**
   */
  componentDidUpdate() {
    const { session } = this.props;

    if (session.isPasswordExpired) {
      this.sendToPasswordResetPage();
    }
  }

  /**
   * @param {Error} error
   * @param {React.ErrorInfo} info
   */
  componentDidCatch(error, info) {
    trackReactComponentError(error, info);
  }

  changePassword = (event) => {
    this.setState({
      password: event.target.value
    });
  };

  changeEmail = (event) => {
    this.props.setState("LOGIN", {
      email: event.target.value
    });
  }

  changeTFA = (event) => {
    this.setState({
      TFA: event.target.value
    });
  }

  /**
   * calls redux action LoginUser to log user into app
   */
  checkUser = () => {
    const { password } = this.state;
    const { loginUser, login } = this.props;
    const { email } = login;

    loginUser(email, password);
  }

  resetEmail = () => {
    const { email } = this.props.login;

    if (isEmail(email)) {
      this.props.resetPassword(
        email
      );
      this.setState({
        isEmailValid: true,
        showEmailConfirmation: true
      });
    } else {
      this.setState({
        isEmailValid: false
      });
    }
  }

  checkTFA = () => {
    const { TFA } = this.state;
    this.props.checkTFA(TFA);
  }

  changeResetEmail = (event) => {
    this.props.setState("LOGIN", {
      email: event
    });

    this.setState({
      isEmailValid: isEmail(this.props.login.email)
    });
  }

  togglePasswordReset = () => {
    this.props.setState("LOGIN", {
      isPasswordResetShown: !this.props.login.isPasswordResetShown
    });
  }

  resetOAuthRequirements = () => {
    this.props.resetOAuthRequirements();
  }

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.checkTFA();
    }
  }

  showEmailReset = () => {
    this.setState({
      showEmailConfirmation: false
    });

    this.props.setState("LOGIN", {
      isPasswordResetShown: true
    });
  }

  handleCloseNotification = () => {
    const { resetNotificationError } = this.props;
    resetNotificationError();
  }

  /**
   * toggles off confirmation and shows login component
   */
  hideEmailConfirmation = () => {
    this.setState({
      showEmailConfirmation: false
    });
  }

  /**
   * redirects users to reset password page
   */
  sendToPasswordResetPage() {
    const { setPage, session } = this.props;
    setPage(`/users/reset/${session.token}`);
  }

  /**
   *
   * @returns {Object}
   */
  render() {
    const {
      client,
      login,
      session
    } = this.props;

    const {
      isEmailValid, password, showEmailConfirmation, TFA
    } = this.state;

    if (!client) {
      return <Loading />;
    }

    const showBaseLoginForm = (
      !session.isPasswordExpired &&
      !session.requireOAuth &&
      !login.isPasswordResetShown &&
      !showEmailConfirmation &&
      !session.requiresMfa
    );

    return (
      <>
        {!showEmailConfirmation && (
          <div className="Login g-view">
            <Canvas className="form">
              {session.requireOAuth && !session.requiresMfa && (
                <OauthForm
                  login={login}
                  session={session}
                  changeTFA={this.changeTFA}
                  checkTFA={this.checkTFA}
                  resetOAuthRequirements={this.resetOAuthRequirements}
                  TFA={TFA}
                />
              )}
              {login.isPasswordResetShown && !showEmailConfirmation && (
                <PasswordResetForm
                  login={login}
                  resetEmail={this.resetEmail}
                  changeResetEmail={this.changeResetEmail}
                  togglePasswordReset={this.togglePasswordReset}
                  isEmailValid={isEmailValid}
                />
              )}
              {session.requiresMfa && (
                <EnforcedMFA />
              )}
              {showBaseLoginForm && (
                <BaseLoginForm
                  login={login}
                  session={session}
                  changePassword={this.changePassword}
                  changeEmail={this.changeEmail}
                  togglePasswordReset={this.togglePasswordReset}
                  setState={setState}
                  resetNotificationError={this.handleCloseNotification}
                  checkUser={this.checkUser}
                  password={password}
                />
              )}
            </Canvas>
          </div>
        )}
        {!showEmailConfirmation && <Footer />}
        {showEmailConfirmation && (
          <PasswordResetEmailConfirmation
            sendToResetPage={this.hideEmailConfirmation}
            resetEmail={this.resetEmail}
            email={login.email}
            hideConfirmation={this.hideEmailConfirmation}
          />
        )}

      </>
    );
  }
}


Login.propTypes = {
  client: PropTypes.instanceOf(Client),
  login: PropTypes.instanceOf(Record).isRequired,
  loginUser: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  session: PropTypes.instanceOf(Record).isRequired,
  fetchClient: PropTypes.func.isRequired
};

Login.defaultProps = {
  client: null
};

function mapState(state) {
  const { login, session } = state;

  return {
    client: getResource(state, "client"),
    login,
    session
  };
}

function mapDispatch(dispatch) {
  return {
    setState: bindActionCreators(setState, dispatch),
    setPage: bindActionCreators(setPageAction, dispatch),
    checkTFA: bindActionCreators(checkTFA, dispatch),
    resetPassword: bindActionCreators(resetPassword, dispatch),
    loginUser: bindActionCreators(loginUserAction, dispatch),
    resetNotificationError: bindActionCreators(ResetErrorNotificationAction, dispatch),
    resetOAuthRequirements: bindActionCreators(
      resetOAuthRequirements,
      dispatch
    ),
    fetchClient: () => dispatch(fetchOne("client"))
  };
}

const Connector = connect(mapState, mapDispatch)(Login);

export default Connector;
